document.addEventListener('DOMContentLoaded', function () {
  function enforceMinQty(input) {
    const min = parseInt(input.getAttribute('min') || 1);
    if (parseInt(input.value) < min) {
      input.value = min;
    }
  }

  // Bewaakt de quantity input op de productpagina
  document.querySelectorAll('.quantity__input').forEach(function (input) {
    input.addEventListener('change', function () {
      enforceMinQty(this);
    });

    // Zet direct de min-waarde als startwaarde
    enforceMinQty(input);
  });

  // Blokkeer form submit als waarde toch te laag is
  document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      const input = form.querySelector('.quantity__input');
      if (!input) return;
      const min = parseInt(input.getAttribute('min') || 1);
      const val = parseInt(input.value);
      if (val < min) {
        e.preventDefault();
        e.stopImmediatePropagation();
        alert(`Minimale bestelhoeveelheid is ${min} stuks.`);
        input.value = min;
      }
    });
  });
});
